<template>
  <div id="roadSideCarPresentList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>路侧数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>在场数据查询</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;"
                       @change="loadPark">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fInParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备账号::">
            <el-select v-model="pageSearch.fDevAccID"
                       clearable
                       filterable
                       placeholder="请选择设备"
                       style="width:200px;">
              <el-option v-for="item in devacc_list"
                         :key="item.fDevAccID"
                         :label="item.fDevAccNo+':'+item.fLinkman"
                         :value="item.fDevAccID">
                <!-- <span style="float: left">{{ item.fDevAccNo }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.fLinkman }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="通道::">
            <el-select v-model="pageSearch.fInChnlID"
                       filterable
                       placeholder="请选择通道"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in channel_list"
                         :key="item.fChnlID"
                         :label="item.fChnlName"
                         :value="item.fChnlID">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="车牌::">
            <el-input placeholder="请输入车牌"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-checkbox v-model="pageSearch.isPre">只显示预付记录</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row class="tabRow">
      <el-table :data="pageData"
                :height="tableHeight"
                highlight-current-row
                v-loading="loading"
                border
                stripe
                style="width: 100%">
        <el-table-column width="50"
                         type="index"
                         :index="indexMethod"
                         label="序号">
        </el-table-column>
        <el-table-column prop="fCustNo"
                         width="80"
                         label="客户编号">
        </el-table-column>
        <el-table-column prop="fOpUserName"
                         width="140"
                         label="最后操作人">
        </el-table-column>
        <el-table-column prop="fInTime"
                         width="160"
                         label="进场时间">
        </el-table-column>
        <el-table-column prop="fPlateCode"
                         width="100"
                         label="车牌号码">
        </el-table-column>
        <el-table-column prop="fPlateColor"
                         width="80"
                         label="车牌颜色">
        </el-table-column>
        <el-table-column prop="fIsCard"
                         width="80"
                         label="是否月车">
        </el-table-column>
        <el-table-column prop="fInParkName"
                         label="进场场库">
        </el-table-column>
        <!-- <el-table-column prop="fChnlName"
                         label="进场通道">
        </el-table-column> -->
        <el-table-column prop="fInStatus"
                         width="90"
                         label="进场方式">
        </el-table-column>
        <el-table-column prop="fCarNumber"
                         width="80"
                         label="车位编号">
        </el-table-column>
        <el-table-column prop="fRateGroupName"
                         label="费率名称">
        </el-table-column>
        <el-table-column prop="fPayAmt"
                         align="right"
                         width="100"
                         label="预付金额">
        </el-table-column>
        <!-- <el-table-column width="80"
                         label="是否欠费">
          <template slot-scope="scope">
            <el-tag type="danger"
                    effect="dark"
                    v-if="scope.row.fIsArr=='1'">是</el-tag>
            <el-tag type="success"
                    effect="dark"
                    v-if="scope.row.fIsArr=='0'">否</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="fInRemark"
                         label="进场备注">
        </el-table-column>
        <el-table-column label="操作"
                         fixed="right"
                         align="center"
                         width="270">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="success"
                       style="width:70px;padding:7px 0px;"
                       @click="handleInfo(scope.$index, scope.row)">查看{{(scope.row.fIsArr=='1'?"(欠)":"")}}</el-button>
            <el-button size="mini"
                       type="primary"
                       v-if="is_edit"
                       @click="updatePlateCode(scope.$index, scope.row)">修改车牌</el-button>
            <el-button size="mini"
                       type="danger"
                       v-if="is_del"
                       @click="deleteInfo(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24">
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout=" total, sizes,prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <roadSideCarInfoView ref="child"
                         :type="1"></roadSideCarInfoView>

    <el-dialog :title="modify_title"
               v-dialogDrag
               width="40%"
               id="modify_dialog"
               :visible.sync="dialogVisible">
      <el-form :model="plateModel"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="车牌号码::">
              <el-input v-model="plateModel.fPlateCode"
                        style="width:200px"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="进场识别车牌::">
              <el-input v-model="plateModel.fInPlate"
                        style="width:200px"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="修改车牌为::"
                          prop="fModifiedPlate">
              <el-input v-model="plateModel.fModifiedPlate"
                        placeholder="请输入车牌"
                        style="width:200px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24"
                  class="tab_img">
            <div class="block">
              <span class="demonstration"
                    style="color:red">{{plateModel.fInExpiredTip}}</span>
              <el-image :src="plateModel.fInPic">
                <div slot="error"
                     class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <el-image :src="plateModel.fInPlatePic">
                <div slot="error"
                     class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import roadSideCarInfoView from '../../../components/roadSideCarInfoView'
import { report as api } from '../../../api/roadSideReport'
import * as park from '../../../api/park'
import * as user from '../../../api/user'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  components: { roadSideCarInfoView },
  data () {
    return {
      plateModel: {
        fBigRowID: '',
        fModifiedPlate: ''
      },
      dialogVisible: false,
      modify_title: '',
      is_del: false,
      is_export: false,
      is_edit: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      reportActiveName: 'pageData',
      pageData: [],
      cust_list: [],
      park_list: [],
      channel_list: [],
      devacc_list: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fInParkID: '',
        fDevAccID: '',
        fInChnlID: '',
        searchKeyWord: '',
        isPre: false
      },
      rules: {
        fModifiedPlate: [
          { required: true, message: '请输入车牌', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.page_list()
      }, 1000)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      api.carPresentList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载在场数据失败')
          }
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api.roadSideModifyPlateCode({ fPlateCode: this.plateModel.fModifiedPlate, fBigRowID: this.plateModel.fBigRowID }).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init()
              } else {
                this.$message.error(data.Msg)
              }
            }
          })
        }
      })
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      this.pageSearch.isSync = this.reportActiveName === 'synPageData'
      api.roadSideCarPresentExport(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_在场数据.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    loadPark (fCustID) {
      this.pageSearch.fInParkID = ''
      this.park_list = []
      this.pageSearch.fInChnlID = ''
      this.channel_list = []
      this.pageSearch.fDevAccID = ''
      this.devacc_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
      api.pdaList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.devacc_list = data.Data || []
          } else {
            this.$message.error('提示：加载设备账号列表失败')
          }
        }
      })
    },
    changeChannel (val) {
      // 加载在场数据列表
      this.page_list()
    },
    init () {
      park.getCustByGroup({ fCustTypeID: 1 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    updatePlateCode (index, row) {
      api.carBusInfo({ type: 1, id: row.fBigRowID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var rowData = data.Data || {}
            if ((rowData.fInPic || '').length <= 0) {
              rowData.fInPic = ' '
            }
            if ((rowData.fOutPic || '').length <= 0) {
              rowData.fOutPic = ' '
            }
            rowData.fModifiedPlate = ''
            Object.assign(this.plateModel, rowData)
            this.modify_title = '【' + rowData.fCustName + '-' + rowData.fInParkName + '】修改车牌'
            this.dialogVisible = true
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    deleteInfo (index, row) {
      this.$confirm('请确认是否删除[车牌:' + row.fPlateCode + ' 进场时间:' + row.fInTime + ']在场记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteCarPresent({ fBigRowID: row.fBigRowID }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.$message({
                type: 'success',
                message: data.Msg
              })
              this.page_list()
            } else {
              this.$message.error('提示：' + data.Msg)
            }
          }
        })
      }).catch(() => { })
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 245
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 110000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_del = data.Data.data.is_del
            this.is_export = data.Data.data.is_export
            this.is_edit = data.Data.data.is_edit
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#roadSideCarPresentList #roadSideCarInfoView .el-dialog {
  min-width: 840px;
}
#roadSideCarPresentList #modify_dialog .el-dialog {
  min-width: 400px;
}
#roadSideCarPresentList #modify_dialog .tab_img .block {
  text-align: center;
  position: relative;
  margin-top: 10px;
}
#roadSideCarPresentList #modify_dialog .tab_img .demonstration {
  display: block;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
}
#roadSideCarPresentList #modify_dialog .tab_img .el-image {
  width: 150px;
  height: auto;
  display: inline-block;
  margin-left: 10px;
}
#roadSideCarPresentList #modify_dialog .tab_img .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
#roadSideCarPresentList .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#roadSideCarPresentList .el-dialog__title {
  color: white;
}
#roadSideCarPresentList .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#roadSideCarPresentList .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#roadSideCarPresentList .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#roadSideCarPresentList .tabRow .el-tabs__header {
  margin: 0px;
}
#roadSideCarPresentList .el-input.is-disabled .el-input__inner,
#roadSideCarPresentList .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#roadSideCarPresentList .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#roadSideCarPresentList .el-input__icon {
  line-height: 32px;
}
/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/view/roadSidePark/report/roadSideCarPresentList.vue